import React, { useCallback } from "react";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
} from "@material-ui/core";

const CheckItem = React.memo((props) => {
  const {
    item,
    defaultChecked = false,
    onChange,
    rootIdx,
    childIdx,
    grandChildIdx,
  } = props;
  const [checked, setChecked] = React.useState(defaultChecked);

  const handleToggleCheck = useCallback(() => {
    setChecked(!checked);

    onChange(rootIdx, childIdx, grandChildIdx, !checked);
  }, [checked, onChange, rootIdx, childIdx, grandChildIdx]);

  return (
    <ListItem dense button onClick={handleToggleCheck}>
      <ListItemIcon>
        <Checkbox disableRipple checked={checked} />
      </ListItemIcon>
      <ListItemText>{item.name}</ListItemText>
    </ListItem>
  );
});

export default CheckItem;
